import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useMessagingPaths } from "@circle-react/hooks/chatsV2/messaging/useMessagingPaths";
import { useNavigate } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";
import {
  reactQueryGet,
  reactQueryPost,
} from "@/react/helpers/backendRequestHelpers";
import { notifyBugsnag } from "@/react/helpers/bugsnagHelpers";

export const useChatRoom = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { chatRoomPath } = useMessagingPaths();

  const findChatRoom = async ({
    shouldNavigate = false,
    ...communityMembersData
  }) => {
    try {
      const { community_member_ids } = communityMembersData;
      const response = await reactQueryGet(
        internalApi.chatRooms.fetch({
          params: { community_member_ids },
        }),
      );
      const { uuid: currentChatRoomUuid } = response;
      shouldNavigate &&
        void navigate({ href: chatRoomPath({ uuid: currentChatRoomUuid }) });
      return currentChatRoomUuid;
    } catch (err: any) {
      toast.error(t("something_went_wrong"));
      notifyBugsnag(err);
    }
  };

  const findOrCreateChatRoom = async ({
    shouldNavigate = false,
    ...communityMembersData
  }) => {
    try {
      const data = { chat_room: communityMembersData };
      const response = await reactQueryPost(internalApi.chatRooms.create(), {
        ...data,
      });
      const currentChatRoomUuid = response.chat_room.uuid;
      shouldNavigate &&
        void navigate({
          href: chatRoomPath({ uuid: response.chat_room.uuid }),
        });
      return currentChatRoomUuid;
    } catch (err: any) {
      toast.error(err.errorDetails?.message || err.message);
      notifyBugsnag(err);
    }
  };

  return { findChatRoom, findOrCreateChatRoom };
};
